export const sanitize = (variables, types) => {
    const typedVariables = {};
    for (const [key, value] of Object.entries(variables)) {
        if (types[key] === undefined) {
            continue;
        }
        if (!Array.isArray(types[key])) {
            typedVariables[key] = typeof(value) === types[key].name.toLowerCase() ? value : types[key](value);
        } else {
            if (!Array.isArray(value)) {
                console.error(`variable ${key} must be array; is ${value} instead`);
            }
            typedVariables[key] = Array.isArray(value) ? value.map( x => types[key][0](x)) : [ types[key][0](value) ]
        }
    }
    return typedVariables;
}
